import React from 'react'
import { List, ListItem, ListItemIcon } from '@mui/material'
import { KeyboardArrowRight, CalendarTodayOutlined } from '@mui/icons-material'
import PageWithTitleLayout from '../Layout/PageWithTitleLayout'
import { useStickyState } from '../../Utilities/useStickyState'
import moment from 'moment'
import { PATHS } from '../../constants'
import ViewOnlyStoreSelect, { VIEW_ONLY_STORE_KEY } from './ViewOnlyStoreSelect'

const ViewOnlyHome = ({ history }) => {
    const [selectedStore, setSelectedStore] = useStickyState(null, VIEW_ONLY_STORE_KEY)

    const now = new Date()
    const months = [
        new Date(now.getFullYear(), now.getMonth()),
        new Date(now.getFullYear(), now.getMonth() + 1),
        new Date(now.getFullYear(), now.getMonth() + 2)
    ]

    return (
        <PageWithTitleLayout title="ホーム" titleOnly={true}>
            {/* width:100% + .shrinkable's 35% side margins overflows the home content area */}
            <ViewOnlyStoreSelect
                sx={{ mx: '1rem' }}
                navigateOnChange={false}
                selectedStore={selectedStore}
                onSelectedStoreChange={setSelectedStore}
            />
            <div className="shrinkable">
                <List>
                    {selectedStore?.sample_employment_id &&
                        months.map(e => {
                            const month = e.getMonth() + 1 // js months are 0 index
                            return (
                                <ListItem
                                    key={month}
                                    onClick={() => {
                                        const selectedYearMonth = moment(e).format('YYYY-MM')
                                        localStorage.setItem(
                                            'frederickSelectedYearMonth',
                                            JSON.stringify(selectedYearMonth)
                                        )
                                        history.push(
                                            PATHS.shiftManagement
                                                .replace(':employmentId', selectedStore.sample_employment_id)
                                                .replace(':calendarYearMonth', selectedYearMonth)
                                                .replace(':tabValue', 'check')
                                        )
                                    }}
                                >
                                    <ListItemIcon>
                                        <CalendarTodayOutlined />
                                    </ListItemIcon>
                                    {month}月分
                                    <KeyboardArrowRight sx={{ ml: 'auto' }} />
                                </ListItem>
                            )
                        })}
                </List>
            </div>
        </PageWithTitleLayout>
    )
}

export default ViewOnlyHome
